module.exports = __webpack_public_path__ + "87741481e8089f7f73da69b2de02952e.pdf";